<template>
  <div class="progress-status-tag-comp" :class="[progress, type]">
    <div class="flag" v-if="type === 'point'"></div>
    {{ progressLabel }}
  </div>
</template>
<script lang="ts">
import { BaseComponent, Component, Prop } from 'kuaidong-component'
import { DateWrapper } from 'kuaidong-lib'
@Component({
  components: {},
})
export default class ProgressStatusTag extends BaseComponent {
  @Prop({ type: String, required: true })
  startTime!: string

  @Prop({ type: String, required: true })
  endTime!: string

  @Prop({ type: String, default: 'point' })
  type!: 'point' | 'tag'

  get startBegin() {
    return new DateWrapper(this.startTime).date
  }

  get endBegin() {
    return new DateWrapper(this.endTime).date
  }

  get progress() {
    const now = new DateWrapper(new Date()).date
    if (now < this.startBegin) {
      return 'un-start'
    } else if (now > this.endBegin) {
      return 'end'
    } else {
      return 'progress'
    }
  }

  get progressLabel() {
    switch (this.progress) {
      case 'un-start':
        return '未开始'
      case 'progress':
        return '进行中'
      default:
        return '已结束'
    }
  }
}
</script>
<style lang="less">
.progress-status-tag-comp {
  display: flex;
  align-items: center;
  &.un-start {
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    > .flag {
      background: #fe9647;
    }
  }
  &.progress {
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    > .flag {
      background: #3366ff;
    }
  }
  &.end {
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    > .flag {
      background: #b8b8b8;
    }
  }
  > .flag {
    width: 6px;
    height: 6px;
    margin-right: 4px;
    border-radius: 50%;
  }

  &.tag {
    padding: 2px 4px;
    border-radius: 4px;

    &.un-start {
      color: #fe9647;
      background: #ffefe3;
    }
    &.progress {
      background: #e4fae1;
      color: #1e9d0a;
    }
    &.end {
      color: #81848f;
      background: #f7f8fa;
    }
  }
}
</style>
